export default "__VITE_ASSET__Bbo7Yk3p__"